<div fxLayout="row">
    <ng-container *ngFor="let section of configuration.sections">
        <ng-content></ng-content>
        <div *ngIf="section?.backButton">
            <ng-container *ngIf="!section.backButton?.content; else Content">
                <span mat-button [ngClass]="section.backButton.styles"
                    (click)="goToPreviousPage()">
                    <mat-icon class="arrowBack">arrow_back</mat-icon>
                </span>
            </ng-container>
            <ng-template #Content>
                <span mat-button [ngClass]="section.backButton.styles"
                    (click)="goToPreviousPage()">{{section.backButton.content}}</span>
            </ng-template>
        </div>
    </ng-container>
</div>